const SectionHeading = ({ eyebrow, title, description, align = "left", light = false }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p
        className={`text-xs font-semibold uppercase tracking-[0.2em] ${
          light ? "text-blue-400" : "text-[#2563EB]"
        }`}
      >
        {eyebrow}
      </p>
    )}
    <h2
      className={`mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${
        light ? "text-white" : "text-slate-900"
      }`}
    >
      {title}
    </h2>
    {description && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>
        {description}
      </p>
    )}
  </div>
);

export default SectionHeading;
